import { render, staticRenderFns } from "./ItemSourceDetailModal.vue?vue&type=template&id=45f9a71a&"
import script from "./ItemSourceDetailModal.vue?vue&type=script&lang=js&"
export * from "./ItemSourceDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./ItemSourceDetailModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports